import { isCancel } from 'axios';
import CrashlyticsService from 'src/data/services/CrashlyticsService';
import type ApiRequestError from 'src/core/models/api/ApiRequestError';

export const isSupersededRequest = (error: unknown): boolean => isCancel(error);

export const reportToCallerOrCrashlytics = ({
	message,
	error,
	onError,
}: {
	message: string;
	error: ApiRequestError;
	onError?: ((error: ApiRequestError) => void) | undefined;
}): void => {
	if (isSupersededRequest(error)) {
		return;
	}

	if (onError) {
		onError(error);

		return;
	}

	CrashlyticsService.captureEvent({ message, extra: { error } });
};
